"use client";

import { motion } from "framer-motion";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** 스크롤 인 시 지연 (순차 등장용) — 0 이면 즉시 */
  delay?: number;
  /** y 이동 거리 (px). 기본 8 */
  y?: number;
  /** 뷰포트 margin — 살짝 일찍 트리거 */
  rootMargin?: string;
  className?: string;
  id?: string;
}

/**
 * 카드·섹션을 스크롤 인 시 fade-up 애니메이션으로 감쌈 (R1-11).
 *
 * - IntersectionObserver(framer-motion `whileInView`) 기반
 * - 한 번만 동작 (`once: true`) — 재진입 시 반복 애니 없음
 * - 다크 테마의 시각적 리듬감·카드 스태거 효과 위주
 *
 * 주의: framer-motion 의 `onDrag` 등 Pan 핸들러가 React DragEvent 와 타입 충돌 →
 * spread props 빼고 명시적 props (className, id) 만 받음.
 */
export function FadeIn({
  children,
  delay = 0,
  y = 8,
  rootMargin = "-40px",
  className,
  id,
}: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: rootMargin }}
      transition={{ duration: 0.4, delay, ease: [0.22, 0.61, 0.36, 1] }}
      className={className}
      id={id}
    >
      {children}
    </motion.div>
  );
}
